import React, { useEffect, useState } from 'react';
import DropdownManager from './DropdownManager';
import LoadingState from './LoadingState';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

/**
 * Standalone dropdown editor for non-owner roles (e.g. a General Manager granted
 * the 'edit-dropdowns' permission). Owners edit dropdowns from the Dealerships page;
 * this view scopes a GM to only the dealership(s) they manage. The dealership list
 * comes from the GM-aware /api/user-management/dealerships endpoint.
 */
export default function GmDropdowns({ user }) {
  const [dealerships, setDealerships] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDealerships = async () => {
      try {
        const token = localStorage.getItem('token');
        const headers = {};
        if (token) headers['Authorization'] = `Bearer ${token}`;

        const res = await fetch(`${API_URL}/api/user-management/dealerships`, {
          credentials: 'include',
          headers
        });
        if (!res.ok) throw new Error('Failed to load dealerships');

        const data = await res.json();
        const list = data.dealerships || [];
        setDealerships(list);
        if (list.length > 0) setSelectedId(list[0].id);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDealerships();
  }, []);

  if (loading) {
    return <LoadingState message="Loading dealerships..." fullscreen />;
  }

  if (error) {
    return <div className="user-management-error">Error: {error}</div>;
  }

  if (dealerships.length === 0) {
    return (
      <div className="user-management-empty">
        <p>No dealerships available. Contact an administrator.</p>
      </div>
    );
  }

  return (
    <div className="user-management">
      <div className="user-management-header">
        <div className="header-title">
          <h1>Dealership Dropdowns</h1>
          <p>Customize dropdown options (lenders, fit specialists, providers, models, etc.)</p>
        </div>
      </div>

      {dealerships.length > 1 && (
        <div className="form-group" style={{ marginBottom: '1.5rem', maxWidth: '420px' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', color: 'rgba(255,255,255,0.7)', fontSize: '14px' }}>
            Dealership
          </label>
          <select
            value={selectedId}
            onChange={(e) => setSelectedId(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 12px',
              borderRadius: '8px',
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid rgba(0,212,255,0.25)',
              color: '#fff',
              fontSize: '15px'
            }}
          >
            {dealerships.map((d) => (
              <option key={d.id} value={d.id}>{d.name}</option>
            ))}
          </select>
        </div>
      )}

      {selectedId && <DropdownManager dealershipId={selectedId} />}
    </div>
  );
}
